(function(Cosmos) {
  const inicializaToast = () => {
    $('.toast').toast();
  };

  Cosmos.initToast = inicializaToast;
  Cosmos.initToast();
})(window.Cosmos);
// ************************* FIM DO toast.js *************************
